import { useState } from 'react';
import globalStyles from './global.module.css';
import ShareIcon from './img/square-share-line.svg';

interface SendPdfButtonProps {
    onClick?: () => Promise<unknown> | unknown;
    disabled?: boolean;
}

function SendPdfButton({ onClick, disabled = false }: SendPdfButtonProps) {
    const [loading, setLoading] = useState(false);

    const handleClick = async () => {
        if (onClick) {
            setLoading(true);
            try {
                await onClick();
            } finally {
                setLoading(false);
            }
        }
    };

    return (
        <button
            className={`${globalStyles.labeledButton} ${loading ? globalStyles.loading : ''}`}
            onClick={handleClick}
            disabled={disabled || loading}
            title={loading ? 'PDF wird verschickt …' : 'Stundenplan als PDF an alle Studierenden mailen'}
        >
            <img
                src={ShareIcon}
                alt=""
                aria-hidden="true"
                className={globalStyles.labeledButtonIcon}
            />
            <span>{loading ? 'Wird verschickt …' : 'An Studierende senden'}</span>
        </button>
    );
}

export default SendPdfButton;
